export const getIdsFromPaints = (paints) => {
  let ids = [];
  paints.forEach((item) => {
    if (item.orders) ids = ids.concat(item.orders);
  });
  return ids;
};
